import BaseUtil from "../util/BaseUtil";
import FunctionUtil from "../util/FunctionUtil";

const CERT_DOCTOR_SCOPE_MAP = {
    临床: ["内科专业", "外科专业", "妇产科专业", "儿科专业", "眼耳鼻咽喉科专业", "皮肤病与性病专业", "医学影像和放射治疗专业", "医学检验", "病理专业", "急救医学专业", "康复医学专业", "预防保健专业", "精神卫生专业", "全科医学专业", "麻醉学专业", "重症医学科专业", "肿瘤内科专业", "肿瘤外科专业", "小儿麻醉专业", "其他（临床）"],
    中医: ["中医专业", "中西医结合专业", "民族医专业"],
    口腔: ["口腔专业", "口腔麻醉专业", "口腔病理专业", "口腔影像专业", "其他（口腔）"],
    公共卫生: ["公共卫生专业", "妇幼保健专业"],
};

const _codeToDisplay = (obj) => {
    return _.chain(obj)
        .values()
        .keyBy(it => it.code)
        .mapValues(it => it.display)
        .value();
};

export const codeToDisplay = FunctionUtil.memoize(_codeToDisplay);

const FIELD_TYPE = {
    BOOL: {
        code: "BOOL",
        display: "布尔",
    },
    SINGLE_LINE_TEXT: {
        code: "INPUT",
        display: "单行文本",
    },
    MULTI_LINE_TEXT: {
        code: "TEXT",
        display: "多行文本",
    },
    SINGLE_SELECT: {
        code: "RADIO",
        display: "单选",
    },
    MULTI_SELECT: {
        code: "CHECKBOX",
        display: "多选",
    },
    DATE: {
        code: "DATE",
        display: "时间",
    },
    NUMBER: {
        code: "NUMBER",
        display: "数字",
    },
    ATTACH: {
        code: "ATTACH",
        display: "附件",
    },
    PIC: {
        code: "PIC",
        display: "图片",
        addable: false,
    },
    TEXTVIEW: {
        code: "TEXTVIEW",
        display: "显示文本",
        addable: false,
    },
};

const FIELD_TYPE_CODE_TO_DISPLAY_MAP = codeToDisplay(FIELD_TYPE);

const EMPLOYEE_ITEM_GROUP_TYPE = {
    BASIC: {
        code: "BASIC",
        display: "身份信息",
    },
    CONTRACT: {
        code: "CONTRACT",
        display: "联系方式",
    },
    WORK: {
        code: "WORK",
        display: "工作信息",
    },
    CLOTHES: {
        code: "CLOTHES",
        display: "鞋衣帽",
    },
    EMER_CONTR: {
        code: "EMER_CONTR",
        display: "紧急联系人",
    },
    CHILD: {
        code: "CHILD",
        display: "子女信息",
    },

    EVL_JOB_TITLE: {
        code: "EVL_JOB_TITLE",
        display: "职称（评定职称）",
    },
    EMP_JOB_TITLE: {
        code: "EMP_JOB_TITLE",
        display: "职称（聘用职称）",
    },
    DUTY: {
        code: "DUTY",
        display: "职务",
    },
    RANK: {
        code: "RANK",
        display: "护理层级",
    },
    SPEC_QUAL: {
        code: "SPEC_QUAL",
        display: "专科资质",
    },
    SKILL: {
        code: "SKILL",
        display: "职业技能",
    },
    EDU_EXP: {
        code: "EDU_EXP",
        display: "教育经历",
    },
    WORK_EXP: {
        code: "WORK_EXP",
        display: "工作经历",
    },
    ROTATION: {
        code: "ROTATION",
        display: "轮转经历",
    },
    SECONDMENT: {
        code: "SECONDMENT",
        display: "借调经历",
    },
    WORK_UNIT_RECORD: {
        code: "WORK_UNIT_RECORD",
        display: "任职记录",
    },
    MISCONDUCT_DEDUCT: {
        code: "MISCONDUCT_DEDUCT",
        display: "不良行为扣分",
    },
    TRAIN: {
        code: "TRAIN",
        display: "培训",
    },
    TRAIN_METHOD: {
        code: "TRAIN_METHOD",
        display: "理论考核",
    },
    TRAIN_OPERATION: {
        code: "TRAIN_OPERATION",
        display: "技术操作考核",
    },
    ADVANCED_FURTHER: {
        code: "ADVANCED_FURTHER",
        display: "进修",
    },
    ADVANCED_OUTSTUDY: {
        code: "ADVANCED_OUTSTUDY",
        display: "外出学习",
    },
    RESEARCH_PROJECT: {
        code: "RESEARCH_PROJECT",
        display: "科研项目",
    },
    RESEARCH_PAPER: {
        code: "RESEARCH_PAPER",
        display: "论文",
    },
    ACADEMIC_POST: {
        code: "ACADEMIC_POST",
        display: "学术任职",
    },
    CERT_DOCTOR: {
        code: "CERT_DOCTOR",
        display: "医师执业证",
    },
    CERT_NURSE: {
        code: "CERT_NURSE",
        display: "护士执业证",
    },
    CERT_TEACHER: {
        code: "CERT_TEACHER",
        display: "教师资格证",
    },
    CERT_OTHER: {
        code: "CERT_OTHER",
        display: "其他类型证书",
    },
    REWARD: {
        code: "REWARD",
        display: "奖励",
    },
    PUNISHMENT: {
        code: "PUNISHMENT",
        display: "惩罚",
    },
    COMPLAINT: {
        code: "COMPLAINT",
        display: "投诉",
    },
    ATTENDANCE: {
        code: "ATTENDANCE",
        display: "年度考勤",
    },
    ATTACH: {
        code: "ATTACH",
        display: "个人附件",
    },
};

const allKeys = _.keys(EMPLOYEE_ITEM_GROUP_TYPE);
const EMPLOYEE_ITEM_GROUP_TYPE_WITH_SORT_NO = _.mapValues(EMPLOYEE_ITEM_GROUP_TYPE, (values, key) => {
    return {
        ...values,
        sortNo: _.findIndex(allKeys, it => it === key),
    };
});


const EMPLOYEE_BASE_GROUP = [EMPLOYEE_ITEM_GROUP_TYPE.BASIC.code, EMPLOYEE_ITEM_GROUP_TYPE.CONTRACT.code, EMPLOYEE_ITEM_GROUP_TYPE.WORK.code,
    EMPLOYEE_ITEM_GROUP_TYPE.CLOTHES.code, EMPLOYEE_ITEM_GROUP_TYPE.EMER_CONTR.code];

const EMPLOYEE_ITEM_GROUP_TYPE_CODE_TO_DISPLAY_MAP = codeToDisplay(EMPLOYEE_ITEM_GROUP_TYPE);

const RENYUAN_USER_TYPE = { // 人员人员类别
    DOCTOR: {
        code: "DOCTOR",
        display: "医生",
    },
    EMPLOYEE: {
        code: "EMPLOYEE",
        display: "护理",
    },
    TECHNICIAN: {
        code: "TECHNICIAN",
        display: "医技",
    },
    SUPPORT: {
        code: "SUPPORT",
        display: "后勤",
    },
    OFFICE: {
        code: "OFFICE",
        display: "行政 ",
    },
    PHARMACY: {
        code: "PHARMACY",
        display: "药学",
    },
};

const USER_TYPE = { // 基座人员类别
    DOCTOR: {
        code: "DOCTOR",
        display: "医生",
    },
    EMPLOYEE: {
        code: "EMPLOYEE",
        display: "护理",
    },
    TECHNICIAN: {
        code: "TECHNICIAN",
        display: "医技",
    },
    SUPPORT: {
        code: "SUPPORT",
        display: "后勤",
    },
    OFFICE: {
        code: "OFFICE",
        display: "行政 ",
    },
    ADVANCED: {
        code: "ADVANCED",
        display: "进修生",
    },
    POSTGRADUATE: {
        code: "POSTGRADUATE",
        display: "研究生",
    },
    NEW_NURSE: {
        code: "NEW_NURSE",
        display: "新护士",
    },
    INTERN: {
        code: "INTERN",
        display: "实习生",
    },
    NON_EMPLOYEE: {
        code: "NON_EMPLOYEE",
        display: "其他",
    },
    PHARMACY: {
        code: "PHARMACY",
        display: "药学",
    },
};

const PERMISSION_TYPE = {
    ALL: {
        code: "ALL",
        display: "全市",
    },
    SELF_DIST: {
        code: "SELF_DIST",
        display: "所在区域",
    },
    SELF_HOSP: {
        code: "SELF_HOSP",
        display: "所在医院",
    },
    MULTI_HOSP: {
        code: "MULTI_HOSP",
        display: "多医院",
    },
};


const UNIT_TYPE = {
    NURSE_UNIT: {
        code: "NURSE_UNIT",
        display: "护理",
    },
    DOCTOR_UNIT: {
        code: "DOCTOR_UNIT",
        display: "医生",
    },
    TECH_UNIT: {
        code: "TECH_UNIT",
        display: "医技",
    },
    SUPPORT_UNIT: {
        code: "SUPPORT_UNIT",
        display: "后勤保障",
    },
    OFFICE_UNIT: {
        code: "OFFICE_UNIT",
        display: "行政",
    },
    COLLAB_UNIT: {
        code: "COLLAB_UNIT",
        display: "协同",
    },
    PHARMACY_UNIT: {
        code: "PHARMACY_UNIT",
        display: "药学",
    },
    OTHER_UNIT: {
        code: "OTHER_UNIT",
        display: "其他",
    },
};

const EMPLOYEE_ITEM_BIZ_TYPE = {
    NURSE: {
        code: "EMP",
        display: "护理人员",
    },
};

const PRODUCT_TYPE = {
    ZHILIANGJIANCHA: {
        code: "ZHILIANGJIANCHA",
        display: "质量检查",
        appIds: [67097],
    },
    PAIBAN: {
        code: "PAIBAN",
        display: "排班",
        appIds: [4058, 69052],
    },
    RENYUAN: {
        code: "RENYUAN",
        display: "人员",
        appIds: [64523, 46737],
    },
};

const SERVICE_TYPE = {
    ATTENDANCE: "ATTENDANCE", // 考勤同步
    ROTATION: "ROTATION", // 人员轮转
};

const EMPLOYEE_FLOW_BIZ_TYPE = {
    SPEC: {
        code: "SPEC",
        display: "专科资质",
    },
    SKILL: {
        code: "SKILL",
        display: "职业技能",
    },
    DUE_DATE: {
        code: "DUEDATE",
        display: "预产期登记",
    },
    ARCHIVE: {
        code: "ARCHIVE",
        display: "档案审批",
    },
    EDUEXP: {
        code: "EDUEXP",
        display: "教育经历",
    },
    ACADIMIC_POST: {
        code: "ACADIMIC_POST",
        display: "学术任职",
    },
    EDU_FURTHER: {
        code: "EDU_FURTHER",
        display: "进修",
    },
    EDU_OUTSTUDY: {
        code: "EDU_OUTSTUDY",
        display: "外出学习",
    },
    RESEARCH_PROJ: {
        code: "RESEARCH_PROJ",
        display: "科研项目",
    },
    RESEARCH_PAPER: {
        code: "RESEARCH_PAPER",
        display: "论文",
    },
    RANK: {
        code: "RANK",
        display: "层级",
    },
    JOBTITLE: {
        code: "JOBTITLE",
        display: "职称",
    },
    DUTY: {
        code: "DUTY",
        display: "职务",
    },
    SECONDMENT: {
        code: "SECONDMENT",
        display: "人员借调",
    },
    REWARD: {
        code: "AWARD",
        display: "奖励",
    },
    CORSS_UNIT_PART_TIME: {
        code: "CORSS_UNIT_PART_TIME",
        display: "多科室兼职",
    },
};

const EMPLOYEE_FLOW_STATUS = {
    PENDING: {
        code: "PENDING",
        display: "审批中",
    },
    WITHDRAW: {
        code: "WITHDRAW",
        display: "已撤销",
    },
    APPROVE: {
        code: "APPROVE",
        display: "已通过",
    },
    DENY: {
        code: "DENY",
        display: "已拒绝",
    },
    DISABLE: {
        code: "DISABLE",
        display: "已拒绝",
    },
};
const EMPLOYEE_FLOW_STATUS_CODE_TO_DISPLAY_MAP = codeToDisplay(EMPLOYEE_FLOW_STATUS);

const STATUS_TO_TEXT_COLOR = {
    [EMPLOYEE_FLOW_STATUS.PENDING.code]: "#FF8B00",
    [EMPLOYEE_FLOW_STATUS.APPROVE.code]: "#34C1A2",
    [EMPLOYEE_FLOW_STATUS.WITHDRAW.code]: "#90A4AD",
    [EMPLOYEE_FLOW_STATUS.DENY.code]: "#F85853",
    [EMPLOYEE_FLOW_STATUS.DISABLE.code]: "#F85853",
};

// 档案邀请填写时，变更类型
const ARCHIVE_CHANGELOG_CATEGORY = {
    ITEM: "ITEM", // 字段
    RECORD: "RECORD", // 记录
};

// 档案邀请填写时，修改类型
const ARCHIVE_CHANGELOG_TYPE = {
    CREATE: "CREATE", // 新增
    UPDATE: "UPDATE", // 更新
    DELETE: "DELETE", // 删除
};

const EMPLOYEE_SECONDMENT_FORM_ITEM_TYPE = {
    UNIT_STATUS: "UNIT_STATUS", // 科室当前情况
    REQUIRE_DEPLOY: "REQUIRE_DEPLOY", // 对借调护理人员要求-由上级调配
    REQUIRE_ASSIGN: "REQUIRE_ASSIGN", // 对借调护理人员要求-指定人员
    REVIEW: "REVIEW", // 借调评价
};

const EMPLOYEE_SECONDMENT_FLOW_REQUIRED_TYPE = {
    LEADER: "LEADER", // 上级指派
    ASSIGN: "ASSIGN", // 指定人员

    UNIT: "UNIT", // 科室内调配
    DEPT: "DEPT", // 护理部调配
};

const QUALITY_CONTROL_TYPE = {
    NURSE_COUNT: "NURSE_COUNT",
    HR_JOBTITLE: "HR_JOBTITLE",
    HR_EDUBG: "HR_EDUBG",
    HR_WORKYEARS: "HR_WORKYEARS",
    DIMISSION_NURSE_COUNT: "DIMISSION_NURSE_COUNT",
    DIMISSION_JOBTITLE: "DIMISSION_JOBTITLE",
    DIMISSION_EDUBG: "DIMISSION_EDUBG",
    DIMISSION_WORKYEARS: "DIMISSION_WORKYEARS",
};


const ROLE_TYPE = {
    SUPER_ADMIN: "SUPER_ADMIN", // 超级管理员
    ADMIN: "ADMIN", // 管理员,
    SUBADMIN: "SUBADMIN", // 子管理员,
    MANAGER: "MANAGER", // 部门主管,
    NURSE_UNIT: "NURSE_UNIT", // 部门负责人,
    USER: "USER", // 成员,

    MATRON: "MATRON", // 护士长,
    BIG_UNIT: "BIG_UNIT", // 大科室负责人,
    AREA: "AREA", // 院区负责人,
    DEPT: "DEPT", // 护理部,

    CITY_COMMISSION: "CITY_COMMISSION", // 市卫健委,
    DISTRICT_COMMISSION: "DISTRICT_COMMISSION", // 区卫健委,
    CITY_QC_CENTER: "CITY_QC_CENTER", // 市质控中心,
    DISTRICT_QC_CENTER: "DISTRICT_QC_CENTER", // 区质控中心,


    CHIEF_RESIDENT: "CHIEF_RESIDENT", // 住院总,

    OTHER: "OTHER", // 自定义角色
};

const EnvType = {
    LIANFAN: "LIANFAN", // 自建医院
    DINGDING: "DINGDING", // 钉钉医院
    WECHAT: "WECHAT", // 微信公众号医院
    WX_CP: "WX_CP", // 企业微信
    NUMAS: "NUMAS", // 从护理管理同步
};

const BIZ_MODULE_TYPE = {
    PAIBAN: "PAIBAN",
    RENYUAN: "RENYUAN",
    PEIXUN: "PEIXUN",
    ZLJC: "ZLJC",
    BLSJ: "BLSJ",
    HULIRICHANG: "HULIRICHANG",
    GUIPEI: "GUIPEI",
    UNDERLAY: "UNDERLAY",
    JISHUSHOUQUAN: "JISHUSHOUQUAN",
};


// 组织架构数据来源
const ORGANIZATION_SOURCE_TYPE = {
    SELF: "SELF", // 自建
    DINGDING: "DINGDING", // 钉钉
    WX_CP: "WX_CP", // 企业微信
    INHOS_INTERFACE: "INHOS_INTERFACE", // 部署在院内的接口
};

const InHosUserWorkUnitChangePendingStatus = {
    INIT: "INIT",
    IGNORED: "IGNORED",
    DONE: "DONE",
};

const UNDERLAY_APP_MODULE_TYPE = BaseUtil.enumOf([
    {
        key: "ARCHIVE",
        name: "360档案",
    }, {
        key: "MED_GROUP",
        name: "医疗组",
    }, {
        key: "PAIBAN",
        name: "排班",
    }, {
        key: "USER_TRANSFER",
        name: "人员调整",
    }, {
        key: "PEIXUN",
        name: "培训",
    }, {
        key: "ZLJC",
        name: "质量检查",
    }, {
        key: "BLSJ",
        name: "不良事件",
    }, {
        key: "HULIRICHANG",
        name: "工作日常",
    }, {
        key: "GUIPEI",
        name: "规培",
    }, {
        key: "WTJC",
        name: "问题检查",
    }, /*  {
        key: "JISHUSHOUQUAN",
        name: "技术授权",
    }, */ {
        key: "CUSTOM",
    },
]);

const SWJW_URL = "http://192.168.17.105:6443/pc/swjwindex.html";

export default {
    ORGANIZATION_SOURCE_TYPE,
    EnvType,
    FIELD_TYPE,
    CERT_DOCTOR_SCOPE_MAP,
    FIELD_TYPE_CODE_TO_DISPLAY_MAP,
    EMPLOYEE_ITEM_GROUP_TYPE,
    EMPLOYEE_ITEM_GROUP_TYPE_WITH_SORT_NO,
    EMPLOYEE_BASE_GROUP,
    EMPLOYEE_ITEM_GROUP_TYPE_CODE_TO_DISPLAY_MAP,

    USER_TYPE,
    UNIT_TYPE,

    EMPLOYEE_ITEM_BIZ_TYPE,
    PRODUCT_TYPE,
    SERVICE_TYPE,

    EMPLOYEE_FLOW_BIZ_TYPE,

    EMPLOYEE_FLOW_STATUS,
    EMPLOYEE_FLOW_STATUS_CODE_TO_DISPLAY_MAP,
    STATUS_TO_TEXT_COLOR,

    ARCHIVE_CHANGELOG_CATEGORY,
    ARCHIVE_CHANGELOG_TYPE,

    EMPLOYEE_SECONDMENT_FORM_ITEM_TYPE,
    EMPLOYEE_SECONDMENT_FLOW_REQUIRED_TYPE,

    QUALITY_CONTROL_TYPE,
    PERMISSION_TYPE,
    ROLE_TYPE,
    BIZ_MODULE_TYPE,
    UNDERLAY_APP_MODULE_TYPE,
    SWJW_URL,
    InHosUserWorkUnitChangePendingStatus,
    RENYUAN_USER_TYPE,
};
